import { useSearchParams } from 'react-router-dom';
import { PrototypeRenderer } from '../../components/PrototypeRenderer/PrototypeRenderer';
import { Alert } from '@hotjar/hotsauce';
import { useEffect } from 'react';

export function PrototypeScreen() {
  const [searchParams] = useSearchParams();
  const url = searchParams.get('test_url');

  useEffect(() => {
    if (!url) {
      console.error('PrototypeScreen: Missing Url');
    }
  }, [url]);

  if (!url) {
    return <Alert kind="danger">Error: Missing Url</Alert>;
  }

  return <PrototypeRenderer url={decodeURIComponent(url)} />;
}
